// removed by extract-text-webpack-plugin
module.exports = {"root":"supervisor-home--root--l4CX39ve","admin-panel":"supervisor-home--admin-panel--3BahgWFz","adminPanel":"supervisor-home--admin-panel--3BahgWFz","background":"supervisor-home--background--3b_2rPTW","label-top":"supervisor-home--label-top--TqQz84HD","labelTop":"supervisor-home--label-top--TqQz84HD","label-center":"supervisor-home--label-center--1VWWYb5Q","labelCenter":"supervisor-home--label-center--1VWWYb5Q","label-bottom":"supervisor-home--label-bottom--QQy0EGx4","labelBottom":"supervisor-home--label-bottom--QQy0EGx4"};


//////////////////
// WEBPACK FOOTER
// ./views/home/supervisor-home/styles.css
// module id = ./views/home/supervisor-home/styles.css
// module chunks = 0